import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import highlight from 'flarum/common/helpers/highlight';
import humanTime from 'flarum/common/helpers/humanTime';
import escapeRegExp from 'flarum/common/utils/escapeRegExp';
import ItemList from 'flarum/common/utils/ItemList';
/**
 * A private message found by the global search: who wrote it, which
 * conversation it is in, and the part of it that matched.
 */
export default class MessageSearchResult extends Component {
  view() {
    const message = this.attrs.message;
    const dialog = message.dialog();
    return m("li", {
      className: "MessageSearchResult",
      "data-index": 'dialog-messages' + message.id(),
      "data-id": message.id()
    }, m(Link, {
      href: dialog ? app.route.dialog(dialog, message.number()) : app.route('messages')
    }, this.contentItems().toArray()));
  }
  contentItems() {
    const items = new ItemList();
    const message = this.attrs.message;
    const dialog = message.dialog();
    const recipient = dialog ? dialog.recipient() : null;
    items.add('avatar', m(Avatar, {
      user: message.user() || null
    }), 100);
    items.add('text', m("div", {
      className: "MessageSearchResult-text"
    }, m("div", {
      className: "MessageSearchResult-title"
    }, m("span", {
      className: "MessageSearchResult-conversation"
    }, app.translator.trans('flarum-messages.forum.search_source.conversation_with', {
      username: username(recipient || null)
    })), humanTime(message.createdAt())), m("div", {
      className: "MessageSearchResult-excerpt"
    }, highlight(message.contentPlain() ?? '', this.highlightRegExp(), 175))), 90);
    return items;
  }

  /** The query's words, each found wherever it appears, as core highlights post excerpts. */
  highlightRegExp() {
    const phrase = escapeRegExp(this.attrs.query);
    return new RegExp(phrase + '|' + phrase.trim().replace(/\s+/g, '|'), 'gi');
  }
}
flarum.reg.add('flarum-messages', 'forum/components/MessageSearchResult', MessageSearchResult);